import { DateTime } from "luxon";
import { useCallback, useEffect, useMemo, useState } from "react";
import seedrandom from "seedrandom";
import {
  townsWithImage,
  Town,
} from "../domain/towns";
import { Guess, loadAllGuesses, saveGuesses } from "../domain/guess";

const forcedTowns: Record<string, string> = {
  "2022-04-14": "46072",
  "2022-04-15": "12028",
  "2022-04-16": "03140",
  "2022-04-17": "03018",
  "2022-04-18": "12089",
  "2022-04-19": "46249",
  "2022-04-20": "46145",
  "2022-04-21": "46092",
  "2022-04-22": "46194",
  "2022-04-23": "03009",
  "2022-04-24": "12093",
  "2022-04-25": "03066",
  "2022-04-26": "46213",
  "2022-04-27": "03063",
  "2022-04-28": "12138",
  "2022-04-29": "03105",
  "2022-04-30": "46131",
  "2022-05-01": "12045",
  "2022-05-02": "46235",
  "2022-05-03": "03076",
  "2022-05-04": "46244",
  "2022-05-05": "12126",
  "2022-05-06": "46254",
  "2022-05-07": "46017",
  "2022-05-08": "12027",
  "2022-05-09": "46001",
  "2022-05-10": "46126",
  "2022-05-11": "03031",
  "2022-05-12": "46048",
  "2022-05-13": "12071",
  "2022-05-14": "46029",
  "2022-05-15": "46159",
  "2022-05-16": "12133",
  "2022-05-17": "46220",
  "2022-05-18": "12080",
  "2022-05-19": "46007",
  "2022-05-20": "46147",
  "2022-05-21": "03079",
  "2022-05-22": "12032",
  "2022-05-23": "46257",
  "2022-05-24": "03139",
  "2022-05-25": "46128",
  "2022-05-26": "12051",
  "2022-05-27": "03065",
  "2022-05-28": "46066",
  "2022-05-29": "12135",
  "2022-05-30": "03056",
  "2022-05-31": "03102",
  "2022-06-01": "12082",
  "2022-06-02": "03112",
  "2022-06-03": "46166",
  "2022-06-04": "03099",
  "2022-06-05": "12109",
  "2022-06-06": "46184",
  "2022-06-07": "46201",
  "2022-06-08": "12003",
  "2022-06-09": "03127",
  "2022-06-10": "46083",
  "2022-06-11": "12117",
  "2022-06-12": "46135",
  "2022-06-13": "03082",
  "2022-06-14": "12046",
  "2022-06-15": "12084",
  "2022-06-16": "03048",
  "2022-06-17": "46118",
  "2022-06-18": "03128",
  "2022-06-19": "46250",
  "2022-06-20": "46057",
  "2022-06-21": "46013",
  "2022-06-22": "12059",
  "2022-06-23": "03014",
  "2022-06-24": "46102",
  "2022-06-25": "12128",
  "2022-06-26": "03083",
  "2022-06-27": "46181",
  "2022-06-28": "12014",
  "2022-06-29": "46097",
  "2022-06-30": "46042",
  "2022-07-01": "46105",
  "2022-07-02": "03093",
  "2022-07-03": "46238",
  "2022-07-04": "12009",
  "2022-07-05": "46077",
  "2022-07-06": "03050",
  "2022-07-07": "12029",
  "2022-07-08": "03121",
  "2022-07-09": "46035",
  "2022-07-10": "46078",
  "2022-07-11": "12085",
  "2022-07-12": "03101",
  "2022-07-13": "46169",
  "2022-07-14": "12037",
  "2022-07-15": "12079",
  "2022-07-16": "46190",
  "2022-07-17": "03902",
  "2022-07-18": "03092",
  "2022-07-19": "12026",
  "2022-07-20": "46256",
  "2022-07-21": "03059",
  "2022-07-22": "12104",
  "2022-07-23": "03090",
  "2022-07-24": "46070",
  "2022-07-25": "12040",
  "2022-07-26": "03081",
  "2022-07-27": "46186",
  "2022-07-28": "12140",
  "2022-07-29": "03071",
  "2022-07-30": "46081",
  "2022-07-31": "03096",
  "2022-08-01": "03002",
  "2022-08-02": "12139",
  "2022-08-03": "46183",
  "2022-08-04": "46117",
  "2022-08-05": "03053",
  "2022-08-06": "03122",
  "2022-08-07": "46903",
  "2022-08-08": "46071",
  "2022-08-09": "03011",
  "2022-08-10": "46122",
  "2022-08-11": "03043",
  "2022-08-12": "46015",
  "2022-08-13": "12004",
  "2022-08-14": "46170",
  "2022-08-15": "03119",
  "2022-08-16": "46094",
  "2022-08-17": "12022",
  "2022-08-18": "46113",
  "2022-08-19": "03138",
  "2022-08-20": "46074",
  "2022-08-21": "12901",
  "2022-08-22": "46231",
  "2022-08-23": "46148",
  "2022-08-24": "03019",
  "2022-08-25": "12033",
  "2022-08-26": "46156",
  "2022-08-27": "46202",
  "2022-08-28": "03104",
  "2022-08-29": "46228",
  "2022-08-30": "46089",
  "2022-08-31": "46021",
  "2022-09-01": "46214",
  "2022-09-02": "03015",
  "2022-09-03": "12115",
  "2022-09-04": "46134",
  "2022-09-05": "46174",
  "2022-09-06": "12050",
  "2022-09-07": "46032",
  "2022-09-08": "46037",
  "2022-09-09": "12127",
  "2022-09-10": "46224",
  "2022-09-11": "03047",
  "2022-09-12": "46129",
  "2022-09-13": "46104",
  "2022-09-14": "03060",
  "2022-09-15": "12021",
  "2022-09-16": "46230",
  "2022-09-17": "46099",
  "2022-09-18": "03133",
  "2022-09-19": "12068",
  "2022-09-20": "46246",
  "2022-09-21": "46205",
  "2022-09-22": "03006",
  "2022-09-23": "46011",
  "2022-09-24": "46082",
  "2022-09-25": "46112",
  "2022-09-26": "12011",
  "2022-09-27": "46044",
  "2022-09-28": "46178",
  "2022-09-29": "12077",
  "2022-09-30": "46110",
  "2022-10-01": "46139",
  "2022-10-02": "03094",
  "2022-10-03": "46039",
  "2022-10-04": "03064",
  "2022-10-05": "12110",
  "2022-10-06": "46160",
  "2022-10-07": "46239",
  "2022-10-08": "03075",
  "2022-10-09": "46250",
  "2022-10-10": "46207",
  "2022-10-11": "03021",
  "2022-10-12": "46027",
  "2022-10-13": "12012",
  "2022-10-14": "46177",
  "2022-10-15": "46086",
  "2022-10-16": "46223",
  "2022-10-17": "46132",
  "2022-10-18": "12005",
  "2022-10-19": "46005",
  "2022-10-20": "03028",
  "2022-10-21": "46206",
  "2022-10-22": "46258",
  "2022-10-23": "03089",
  "2022-10-24": "12122",
  "2022-10-25": "46022",
  "2022-10-26": "46109",
  "2022-10-27": "03129",
  "2022-10-28": "46041",
  "2022-10-29": "12141",
  "2022-10-30": "46143",
  "2022-10-31": "03136",
  "2022-11-01": "46116",
  "2022-11-02": "46079",
  "2022-11-03": "46165",
  "2022-11-04": "03049",
  "2022-11-05": "46085",
  "2022-11-06": "46067",
  "2022-11-07": "46234",
  "2022-11-08": "03069",
  "2022-11-09": "46123",
  "2022-11-10": "03114",
  "2022-11-11": "12142",
  "2022-11-12": "46248",
  "2022-11-13": "46018",
  "2022-11-14": "03095",
  "2022-11-15": "46088",
  "2022-11-16": "03137",
  "2022-11-17": "46084",
  "2022-11-18": "03107",
  "2022-11-19": "46163",
  "2022-11-20": "03091",
  "2022-11-21": "46098",
  "2022-11-22": "03116",
  "2022-11-23": "46073",
  "2022-11-24": "03113",
  "2022-11-25": "12056",
  "2022-11-26": "46188",
  "2022-11-27": "03130",
  "2022-11-28": "12031",
  "2022-11-29": "03041",
  "2022-11-30": "46167",
  "2022-12-01": "12052",
  "2022-12-02": "03901",
  "2022-12-03": "03020",
  "2022-12-04": "46020",
  "2022-12-05": "12036",
  "2022-12-06": "03012",
  "2022-12-07": "46120",
  "2022-12-08": "46902",
  "2022-12-09": "03003",
  "2022-12-10": "46242",
  "2022-12-11": "03088",
  "2022-12-12": "46072",
  "2022-12-13": "12028",
  "2022-12-14": "03140",
  "2022-12-15": "12087",
  "2022-12-16": "46106",
  "2022-12-17": "46179",
  "2022-12-18": "46137",
  "2022-12-19": "46111",
  "2022-12-20": "03097",
  "2022-12-21": "12124",
  "2022-12-22": "12093",
  "2022-12-23": "03066",
  "2022-12-24": "46213",
  "2022-12-25": "03083",
  "2022-12-26": "03037",
  "2022-12-27": "12126",
  "2022-12-28": "46232",
  "2022-12-29": "46019",
  "2022-12-30": "46236",
  "2022-12-31": "46125",
  "2023-01-01": "46046",
  "2023-01-02": "46195",
  "2023-01-03": "46006",
  "2023-01-04": "46150",
  "2023-01-05": "03051",
  "2023-01-06": "03009",
  "2023-01-07": "12055",
  "2023-01-08": "46226",
  "2023-01-09": "03103",
  "2023-01-10": "12129",
  "2023-01-11": "46235",
  "2023-01-12": "03076",
  "2023-01-13": "46244",
  "2023-01-14": "03135",
  "2023-01-15": "46254",
  "2023-01-16": "12073",
  "2023-01-17": "12039",
  "2023-01-18": "12114",
  "2023-01-19": "03023",
  "2023-01-20": "46009",
  "2023-01-21": "46054",
  "2023-01-22": "12034",
  "2023-01-23": "03903",
  "2023-01-24": "46058",
  "2023-01-25": "46182",
  "2023-01-26": "46193",
  "2023-01-27": "03039",
  "2023-01-28": "46260",
  "2023-01-29": "12061",
  "2023-01-30": "12100",
  "2023-01-31": "46036",
  "2023-02-01": "46017",
  "2023-02-02": "12027",
  "2023-02-03": "46001",
  "2023-02-04": "12092",
  "2023-02-05": "46181",
  "2023-02-06": "12014",
  "2023-02-07": "46097",
  "2023-02-08": "46042",
  "2023-02-09": "46105",
  "2023-02-10": "46191",
  "2023-02-11": "03025",
  "2023-02-12": "03111",
  "2023-02-13": "46126",
  "2023-02-14": "03031",
  "2023-02-15": "46048",
  "2023-02-16": "12071",
  "2023-02-17": "46029",
  "2023-02-18": "46107",
  "2023-02-19": "03084",
  "2023-02-20": "46087",
  "2023-02-21": "46157",
  "2023-02-22": "03011",
  "2023-02-23": "46122",
  "2023-02-24": "03043",
  "2023-02-25": "46015",
  "2023-02-26": "46115",
  "2023-02-27": "03026",
  "2023-02-28": "03115",
  "2023-03-01": "12082",
  "2023-03-02": "03112",
  "2023-03-03": "46166",
  "2023-03-04": "03099",
  "2023-03-05": "12109",
  "2023-03-06": "03098",
  "2023-03-07": "46251",
  "2023-03-08": "12902",
  "2023-03-09": "03118",
  "2023-03-10": "12053",
  "2023-03-11": "46080",
  "2023-03-12": "03042",
  "2023-03-13": "03139",
  "2023-03-14": "46128",
  "2023-03-15": "12051",
  "2023-03-16": "03065",
  "2023-03-17": "46066",
  "2023-03-18": "12135",
  "2023-03-19": "03056",
  "2023-03-20": "03102",
  "2023-03-21": "46147",
  "2023-03-22": "46026",
  "2023-03-23": "46060",
  "2023-03-24": "46197",
  "2023-03-25": "46145",
  "2023-03-26": "46023",
  "2023-03-27": "46229",
  "2023-03-28": "46198",
  "2023-03-29": "46062",
  "2023-03-30": "46144",
  "2023-03-31": "46130",
  "2023-04-01": "12001",
  "2023-04-02": "03048",
  "2023-04-03": "46118",
  "2023-04-04": "03128",
  "2023-04-05": "03032",
  "2023-04-06": "12119",
  "2023-04-07": "12015",
  "2023-04-08": "12113",
  "2023-04-09": "12008",
  "2023-04-10": "03120",
  "2023-04-11": "12067",
  "2023-04-12": "46172",
  "2023-04-13": "46138",
  "2023-04-14": "03123",
  "2023-04-15": "46171",
  "2023-04-16": "12123",
  "2023-04-17": "03063",
  "2023-04-18": "12138",
  "2023-04-19": "03105",
  "2023-04-20": "46131",
  "2023-04-21": "46014",
  "2023-04-22": "12069",
  "2023-04-23": "46237",
  "2023-04-24": "46124",
  "2023-04-25": "46218",
  "2023-04-26": "46199",
  "2023-04-27": "46168",
  "2023-04-28": "03079",
  "2023-04-29": "12032",
  "2023-04-30": "46257",
  "2023-05-01": "03002",
  "2023-05-02": "46203",
  "2023-05-03": "46209",
  "2023-05-04": "46216",
  "2023-05-05": "12043",
  "2023-05-06": "46093",
  "2023-05-07": "46159",
  "2023-05-08": "12133",
  "2023-05-09": "46220",
  "2023-05-10": "12080",
  "2023-05-11": "46176",
  "2023-05-12": "12088",
  "2023-05-13": "03124",
  "2023-05-14": "46057",
  "2023-05-15": "46013",
  "2023-05-16": "12059",
  "2023-05-17": "03014",
  "2023-05-18": "46102",
  "2023-05-19": "12128",
  "2023-05-20": "46127",
  "2023-05-21": "46136",
  "2023-05-22": "46178",
  "2023-05-23": "46139",
  "2023-05-24": "46045",
  "2023-05-25": "46110",
  "2023-05-26": "46246",
  "2023-05-27": "46205",
  "2023-05-28": "03006",
  "2023-05-29": "46011",
  "2023-05-30": "46082",
  "2023-05-31": "46112",
  "2023-06-01": "12077",
  "2023-06-02": "46178",
  "2023-06-03": "12077",
  "2023-06-04": "12044",
  "2023-06-05": "12070",
  "2023-06-06": "03005",
  "2023-06-07": "12138",
  "2023-06-08": "03024",
  "2023-06-09": "46010",
  "2023-06-10": "46051",
  "2023-06-11": "12089",
  "2023-06-12": "03058",
  "2023-06-13": "03036",
  "2023-06-14": "03016",
  "2023-06-15": "46030",
  "2023-06-16": "03062",
  "2023-06-17": "46101",
  "2023-06-18": "03105",
  "2023-06-19": "12093",
  "2023-06-20": "03068",
  "2023-06-21": "46252",
  "2023-06-22": "03044",
  "2023-06-23": "12038",
  "2023-06-24": "46245",
  "2023-06-25": "46076",
  "2023-06-26": "03070",
  "2023-06-27": "03054",
  "2023-06-28": "03095",
  "2023-06-29": "12096",
  "2023-06-30": "12098",
  "2023-07-01": "03099",
  "2023-07-02": "03033",
  "2023-07-03": "03100",
  "2023-07-04": "03013",
  "2023-07-05": "03117",
  "2023-07-06": "03125",
  "2023-07-07": "03010",
  "2023-07-08": "46114",
  "2023-07-09": "12094",
  "2023-07-10": "03056",
  "2023-07-11": "12103",
  "2023-07-12": "03041",
  "2023-07-13": "03067",
  "2023-07-14": "03068",
  "2023-07-15": "03072",
  "2023-07-16": "03073",
  "2023-07-17": "12083",
  "2023-07-18": "12132",
  "2023-07-19": "12091",
  "2023-07-20": "03138",
  "2023-07-21": "03027",
  "2023-07-22": "03017",
  "2023-07-23": "03125",
  "2023-07-24": "12021",
  "2023-07-25": "46217",
  "2023-07-26": "12108",
  "2023-07-27": "46149",
  "2023-07-28": "46016",
  "2023-07-29": "46065",
  "2023-07-30": "46040",
  "2023-07-31": "12007",
  "2023-08-01": "46095",
  "2023-08-02": "46108",
  "2023-08-03": "46164",
  "2023-08-04": "46151",
  "2023-08-05": "46155",
  "2023-08-06": "03030",
  "2023-08-07": "46233",
  "2023-08-08": "12006",
  "2023-08-09": "12057",
  "2023-08-10": "46048",
  "2023-08-11": "46096",
  "2023-08-12": "12020",
  "2023-08-13": "12097",
  "2023-08-14": "46059",
  "2023-08-15": "03029",
  "2023-08-16": "12095",
  "2023-08-17": "46113",
  "2023-08-18": "46049",
  "2023-08-19": "46154",
  "2023-08-20": "46055",
  "2023-08-21": "46068",
  "2023-08-22": "46196",
  "2023-08-23": "46063",
  "2023-08-24": "46200",
  "2023-08-25": "46056",
  "2023-08-26": "46142",
  "2023-08-27": "46225",
  "2023-08-28": "03132",
  "2023-08-29": "12134",
  "2023-08-30": "46069",
  "2023-08-31": "12078",
  "2023-09-01": "46222",
  "2023-09-02": "12058",
  "2023-09-03": "46185",
  "2023-09-04": "12072",
  "2023-09-05": "46215",
  "2023-09-06": "12002",
  "2023-09-07": "46904",
  "2023-09-08": "12024",
  "2023-09-09": "12048",
  "2023-09-10": "46025",
  "2023-09-11": "46033",
  "2023-09-12": "12106",
  "2023-09-13": "46189",
  "2023-09-14": "12081",
  "2023-09-15": "12063",
  "2023-09-16": "12131",
  "2023-09-17": "12013",
  "2023-09-18": "12015",
  "2023-09-19": "46047",
  "2023-09-20": "12064",
  "2023-09-21": "46086",
  "2023-09-22": "12116",
  "2023-09-23": "12025",
  "2023-09-24": "12012",
  "2023-09-25": "12111",
  "2023-09-26": "03046",
  "2023-09-27": "46240",
  "2023-09-28": "46210",
  "2023-09-29": "46219",
  "2023-09-30": "46003",
  "2023-10-01": "12090",
  "2023-10-02": "46175",
  "2023-10-03": "46075",
  "2023-10-04": "12130",
  "2023-10-05": "46004",
  "2023-10-06": "12010",
  "2023-10-07": "46034",
  "2023-10-08": "46053",
  "2023-10-09": "46208",
  "2023-10-10": "46047",
  "2023-10-11": "12116",
  "2023-10-12": "46090",
  "2023-10-13": "46146",
  "2023-10-14": "46173",
  "2023-10-15": "46255",
  "2023-10-16": "46061",
  "2023-10-17": "46227",
  "2023-10-18": "46259",
  "2023-10-19": "12136",
  "2023-10-20": "03131",
  "2023-10-21": "46140",
  "2023-10-22": "46158",
  "2023-10-23": "46180",
  "2023-10-24": "03085",
  "2023-10-25": "46012",
  "2023-10-26": "46162",
  "2023-10-27": "46241",
  "2023-10-28": "12074",
  "2023-10-29": "46018",
  "2023-10-30": "46031",
  "2023-10-31": "46038",
  "2023-11-01": "03127",
  "2023-11-02": "12112",
  "2023-11-03": "46119",
  "2023-11-04": "12016",
  "2023-11-05": "12075",
  "2023-11-06": "46158",
  "2023-11-07": "03077",
  "2023-11-08": "03086",
  "2023-11-09": "03035",
  "2023-11-10": "46064",
  "2023-11-11": "03038",
  "2023-11-12": "46030",
  "2023-11-13": "12121",
  "2023-11-14": "03019",
  "2023-11-15": "46133",
  "2023-11-16": "03022",
  "2023-11-17": "03055",
  "2023-11-18": "46050",
  "2023-11-19": "46100",
  "2023-11-20": "46024",
  "2023-11-21": "03007",
  "2023-11-22": "12099",
  "2023-11-23": "03104",
  "2023-11-24": "03904",
  "2023-11-25": "46247",
  "2023-11-26": "46008",
  "2023-11-27": "03074",
  "2023-11-28": "46121",
  "2023-11-29": "46243",
  "2023-11-30": "03081",
  "2023-12-01": "12102",
  "2023-12-02": "03134",
  "2023-12-03": "46153",
  "2023-12-04": "46128",
  "2023-12-05": "46221",
  "2023-12-06": "46263",
  "2023-12-07": "12049",
  "2023-12-08": "12107",
  "2023-12-09": "12041",
  "2023-12-10": "03034",
  "2023-12-11": "12137",
  "2023-12-12": "12028",
  "2023-12-13": "03140",
  "2023-12-14": "03018",
  "2023-12-15": "12089",
  "2023-12-16": "46249",
  "2023-12-17": "46145",
  "2023-12-18": "46092",
  "2023-12-19": "46194",
  "2023-12-20": "46001",
  "2023-12-21": "46211",
  "2023-12-22": "03066",
  "2023-12-23": "46213",
  "2023-12-24": "03083",
  "2023-12-25": "12138",
  "2023-12-26": "03076",
  "2023-12-27": "46131",
  "2023-12-28": "03079",
  "2023-12-29": "46235",
  "2023-12-30": "03076",
  "2023-12-31": "46244",
  "2024-01-01": "46152",
  "2024-01-02": "46071",
  "2024-01-03": "46017",
  "2024-01-04": "12027",
  "2024-01-05": "03009",
  "2024-01-06": "46126",
  "2024-01-07": "03031",
  "2024-01-08": "46002",
  "2024-01-09": "12071",
  "2024-01-10": "46029",
  "2024-01-11": "46159",
  "2024-01-12": "46052",
  "2024-01-13": "46220",
  "2024-01-14": "12080",
  "2024-01-15": "46007",
  "2024-01-16": "46147",
  "2024-01-17": "12045",
  "2024-01-18": "12032",
  "2024-01-19": "46257",
  "2024-01-20": "03139",
  "2024-01-21": "46128",
  "2024-01-22": "12051",
  "2024-01-23": "03065",
  "2024-01-24": "12042",
  "2024-01-25": "12135",
  "2024-01-26": "46043",
  "2024-01-27": "03102",
  "2024-01-28": "12082",
  "2024-01-29": "46204",
  "2024-01-30": "46166",
  "2024-01-31": "03001",
  "2024-02-01": "12109",
  "2024-02-02": "46184",
  "2024-02-03": "46201",
  "2024-02-04": "12003",
  "2024-02-05": "03127",
  "2024-02-06": "46083",
  "2024-02-07": "12117",
  "2024-02-08": "46135",
  "2024-02-09": "03082",
  "2024-02-10": "12046",
  "2024-02-11": "12084",
  "2024-02-12": "03048",
  "2024-02-13": "46118",
  "2024-02-14": "03128",
  "2024-02-15": "46250",
  "2024-02-16": "46057",
  "2024-02-17": "46013",
  "2024-02-18": "12059",
  "2024-02-19": "03014",
  "2024-02-20": "46102",
  "2024-02-21": "12128",
  "2024-02-22": "03106",
  "2024-02-23": "46181",
  "2024-02-24": "12014",
  "2024-02-25": "46097",
  "2024-02-26": "46042",
  "2024-02-27": "46105",
  "2024-02-28": "03093",
  "2024-02-29": "46238",
  "2024-03-01": "12009",
  "2024-03-02": "46077",
  "2024-03-03": "03050",
  "2024-03-04": "12029",
  "2024-03-05": "03121",
  "2024-03-06": "46035",
  "2024-03-07": "46078",
  "2024-03-08": "12085",
  "2024-03-09": "03101",
  "2024-03-10": "46169",
  "2024-03-11": "12037",
  "2024-03-12": "12079",
  "2024-03-13": "46190",
  "2024-03-14": "03902",
  "2024-03-15": "03092",
  "2024-03-16": "12026",
  "2024-03-17": "46256",
  "2024-03-18": "03059",
  "2024-03-19": "12104",
  "2024-03-20": "03090",
  "2024-03-21": "46070",
  "2024-03-22": "12040",
  "2024-03-23": "03081",
  "2024-03-24": "46186",
  "2024-03-25": "12140",
  "2024-03-26": "03071",
  "2024-03-27": "46081",
  "2024-03-28": "03096",
  "2024-03-29": "03002",
  "2024-03-30": "12139",
  "2024-03-31": "46183",
  "2024-04-01": "46117",
  "2024-04-02": "03053",
  "2024-04-03": "03122",
  "2024-04-04": "46903",
  "2024-04-05": "46254",
  "2024-04-06": "03011",
  "2024-04-07": "46261",
  "2024-04-08": "03043",
  "2024-04-09": "46015",
  "2024-04-10": "12004",
  "2024-04-11": "46170",
  "2024-04-12": "03119",
  "2024-04-13": "46094",
  "2024-04-14": "12022",
  "2024-04-15": "46113",
  "2024-04-16": "03138",
  "2024-04-17": "46074",
  "2024-04-18": "12901",
  "2024-04-19": "46231",
  "2024-04-20": "46148",
  "2024-04-21": "03019",
  "2024-04-22": "12033",
  "2024-04-23": "46156",
  "2024-04-24": "46202",
  "2024-04-25": "03104",
  "2024-04-26": "46228",
  "2024-04-27": "46089",
  "2024-04-28": "46021",
  "2024-04-29": "46214",
  "2024-04-30": "03015",
  "2024-05-01": "12115",
  "2024-05-02": "46134",
  "2024-05-03": "46174",
  "2024-05-04": "12050",
  "2024-05-05": "46032",
  "2024-05-06": "46037",
  "2024-05-07": "12127",
  "2024-05-08": "46224",
  "2024-05-09": "03047",
  "2024-05-10": "46129",
  "2024-05-11": "46104",
  "2024-05-12": "03060",
  "2024-05-13": "12021",
  "2024-05-14": "46230",
  "2024-05-15": "46099",
  "2024-05-16": "03133",
  "2024-05-17": "12068",
  "2024-05-18": "46246",
  "2024-05-19": "46205",
  "2024-05-20": "03006",
  "2024-05-21": "46011",
  "2024-05-22": "46082",
  "2024-05-23": "46112",
  "2024-05-24": "12011",
  "2024-05-25": "46044",
  "2024-05-26": "46028",
  "2024-05-27": "03008",
  "2024-05-28": "46110",
  "2024-05-29": "46139",
  "2024-05-30": "03094",
  "2024-05-31": "46039",
  "2024-06-01": "03064",
  "2024-06-02": "12110",
  "2024-06-03": "46160",
  "2024-06-04": "46239",
  "2024-06-05": "03075",
  "2024-06-06": "46250",
  "2024-06-07": "46207",
  "2024-06-08": "03021",
  "2024-06-09": "46027",
  "2024-06-10": "12012",
  "2024-06-11": "46177",
  "2024-06-12": "46086",
  "2024-06-13": "46223",
  "2024-06-14": "46132",
  "2024-06-15": "12005",
  "2024-06-16": "46005",
  "2024-06-17": "03028",
  "2024-06-18": "46206",
  "2024-06-19": "46258",
  "2024-06-20": "03089",
  "2024-06-21": "12122",
  "2024-06-22": "46022",
  "2024-06-23": "46109",
  "2024-06-24": "03129",
  "2024-06-25": "46041",
  "2024-06-26": "12141",
  "2024-06-27": "46143",
  "2024-06-28": "03136",
  "2024-06-29": "46116",
  "2024-06-30": "46079",
  "2024-07-01": "46165",
  "2024-07-02": "03049",
  "2024-07-03": "46085",
  "2024-07-04": "46067",
  "2024-07-05": "46234",
  "2024-07-06": "03069",
  "2024-07-07": "46123",
  "2024-07-08": "03114",
  "2024-07-09": "12142",
  "2024-07-10": "46248",
  "2024-07-11": "46018",
  "2024-07-12": "03095",
  "2024-07-13": "46088",
  "2024-07-14": "03137",
  "2024-07-15": "46084",
  "2024-07-16": "03107",
  "2024-07-17": "46163",
  "2024-07-18": "03091",
  "2024-07-19": "46098",
  "2024-07-20": "03116",
  "2024-07-21": "46073",
  "2024-07-22": "03113",
  "2024-07-23": "12056",
  "2024-07-24": "46188",
  "2024-07-25": "03130",
  "2024-07-26": "12031",
  "2024-07-27": "03041",
  "2024-07-28": "46167",
  "2024-07-29": "12052",
  "2024-07-30": "03901",
  "2024-07-31": "03020",
  "2024-08-01": "46020",
  "2024-08-02": "12036",
  "2024-08-03": "03012",
  "2024-08-04": "46120",
  "2024-08-05": "46902",
  "2024-08-06": "03003",
  "2024-08-07": "46242",
  "2024-08-08": "03088",
  "2024-08-09": "46072",
  "2024-08-10": "12028",
  "2024-08-11": "03140",
  "2024-08-12": "12087",
  "2024-08-13": "46106",
  "2024-08-14": "03065",
  "2024-08-15": "46070",
  "2024-08-16": "46078",
  "2024-08-17": "46256",
  "2024-08-18": "12080",
  "2024-08-19": "12018",
  "2024-08-20": "12078",
  "2024-08-21": "12038",
  "2024-08-22": "03040",
  "2024-08-23": "46144",
  "2024-08-24": "12082",
  "2024-08-25": "12130",
  "2024-08-26": "03045",
  "2024-08-27": "03057",
  "2024-08-28": "46077",
  "2024-08-29": "12004",
  "2024-08-30": "46213",
  "2024-08-31": "03134",
  "2024-09-01": "46235",
  "2024-09-02": "03051",
  "2024-09-03": "12100",
  "2024-09-04": "12055",
  "2024-09-05": "03140",
  "2024-09-06": "46249",
  "2024-09-07": "46029",
  "2024-09-08": "46005",
  "2024-09-09": "12104",
  "2024-09-10": "46244",
  "2024-09-11": "03135",
  "2024-09-12": "46254",
  "2024-09-13": "12073",
  "2024-09-14": "12039",
  "2024-09-15": "12114",
  "2024-09-16": "46147",
  "2024-09-17": "46009",
  "2024-09-18": "46054",
  "2024-09-19": "12034",
  "2024-09-20": "03903",
  "2024-09-21": "46058",
  "2024-09-22": "46182",
  "2024-09-23": "46193",
  "2024-09-24": "03076",
  "2024-09-25": "46260",
  "2024-09-26": "46131",
  "2024-09-27": "03009",
  "2024-09-28": "46036",
  "2024-09-29": "46017",
  "2024-09-30": "12027",
  "2024-10-01": "12105",
  "2024-10-02": "12092",
  "2024-10-03": "46181",
  "2024-10-04": "12014",
  "2024-10-05": "46097",
  "2024-10-06": "46042",
  "2024-10-07": "46105",
  "2024-10-08": "46191",
  "2024-10-09": "03025",
  "2024-10-10": "03111",
  "2024-10-11": "46253",
  "2024-10-12": "03045",
  "2024-10-13": "46048",
  "2024-10-14": "12071",
  "2024-10-15": "12129",
  "2024-10-16": "46107",
  "2024-10-17": "03084",
  "2024-10-18": "46087",
  "2024-10-19": "46157",
  "2024-10-20": "03011",
  "2024-10-21": "46122",
  "2024-10-22": "46161",
  "2024-10-23": "46015",
  "2024-10-24": "46115",
  "2024-10-25": "03026",
  "2024-10-26": "03115",
  "2024-10-27": "12082",
  "2024-10-28": "03112",
  "2024-10-29": "46166",
  "2024-10-30": "03099",
  "2024-10-31": "46103",
  "2024-11-01": "03098",
  "2024-11-02": "46251",
  "2024-11-03": "12902",
  "2024-11-04": "03118",
  "2024-11-05": "12053",
  "2024-11-06": "46080",
  "2024-11-07": "03042",
  "2024-11-08": "03139",
  "2024-11-09": "03004",
  "2024-11-10": "46192",
  "2024-11-11": "03065",
  "2024-11-12": "46066",
  "2024-11-13": "12135",
  "2024-11-14": "03056",
  "2024-11-15": "03102",
  "2024-11-16": "46147",
  "2024-11-17": "46026",
  "2024-11-18": "46060",
  "2024-11-19": "46197",
  "2024-11-20": "46145",
  "2024-11-21": "46023",
  "2024-11-22": "46229",
  "2024-11-23": "46198",
  "2024-11-24": "46062",
  "2024-11-25": "46144",
  "2024-11-26": "46130",
  "2024-11-27": "12001",
  "2024-11-28": "46212",
  "2024-11-29": "46118",
  "2024-11-30": "03109",
  "2024-12-01": "03032",
  "2024-12-02": "12119",
  "2024-12-03": "12015",
  "2024-12-04": "12113",
  "2024-12-05": "12008",
  "2024-12-06": "03120",
  "2024-12-07": "12067",
  "2024-12-08": "46172",
  "2024-12-09": "46138",
  "2024-12-10": "03123",
  "2024-12-11": "46171",
  "2024-12-12": "12123",
  "2024-12-13": "03063",
  "2024-12-14": "12138",
  "2024-12-15": "03105",
  "2024-12-16": "46131",
  "2024-12-17": "12045",
  "2024-12-18": "46235",
  "2024-12-19": "03076",
  "2024-12-20": "46244",
  "2024-12-21": "12126",
  "2024-12-22": "46254",
  "2024-12-23": "03079",
  "2024-12-24": "12027",
  "2024-12-25": "46001",
  "2024-12-26": "46126",
  "2024-12-27": "03031",
  "2024-12-28": "46007",
  "2024-12-29": "46017",
  "2024-12-30": "46029",
  "2024-12-31": "46159",
  "2025-01-01": "12032",
  "2025-01-02": "46220",
  "2025-01-03": "46072",
  "2025-01-04": "12028",
  "2025-01-05": "03140",
  "2025-01-06": "03018",
  "2025-01-07": "12089",
  "2025-01-08": "46249",
  "2025-01-09": "46145",
  "2025-01-10": "46092",
  "2025-01-11": "46194",
  "2025-01-12": "03009",
  "2025-01-13": "12093",
  "2025-01-14": "03066",
  "2025-01-15": "46213",
  "2025-01-16": "03063",
  "2025-01-17": "12138",
  "2025-01-18": "03105",
  "2025-01-19": "46131",
  "2025-01-20": "12045",
  "2025-01-21": "46235",
  "2025-01-22": "03076",
  "2025-01-23": "46244",
  "2025-01-24": "12126",
  "2025-01-25": "46254",
  "2025-01-26": "46017",
  "2025-01-27": "12027",
  "2025-01-28": "46001",
  "2025-01-29": "46126",
  "2025-01-30": "03031",
  "2025-01-31": "46048",
  "2025-02-01": "12071",
  "2025-02-02": "46029",
  "2025-02-03": "46159",
  "2025-02-04": "12133",
  "2025-02-05": "46220",
  "2025-02-06": "12080",
  "2025-02-07": "46007",
  "2025-02-08": "46147",
  "2025-02-09": "03079",
  "2025-02-10": "12032",
  "2025-02-11": "46257",
  "2025-02-12": "03139",
  "2025-02-13": "46128",
  "2025-02-14": "12051",
  "2025-02-15": "03065",
  "2025-02-16": "46066",
  "2025-02-17": "12135",
  "2025-02-18": "03056",
  "2025-02-19": "03102",
  "2025-02-20": "12082",
  "2025-02-21": "03112",
  "2025-02-22": "46166",
  "2025-02-23": "03099",
  "2025-02-24": "12109",
  "2025-02-25": "46184",
  "2025-02-26": "46201",
  "2025-02-27": "12003",
  "2025-02-28": "03127",
  "2025-03-01": "46083",
  "2025-03-02": "12117",
  "2025-03-03": "46135",
  "2025-03-04": "03082",
  "2025-03-05": "12046",
  "2025-03-06": "12084",
  "2025-03-07": "03048",
  "2025-03-08": "46118",
  "2025-03-09": "03128",
  "2025-03-10": "46250",
  "2025-03-11": "46057",
  "2025-03-12": "46013",
  "2025-03-13": "12059",
  "2025-03-14": "03014",
  "2025-03-15": "46102",
  "2025-03-16": "12128",
  "2025-03-17": "03083",
  "2025-03-18": "46181",
  "2025-03-19": "12014",
  "2025-03-20": "46097",
  "2025-03-21": "46042",
  "2025-03-22": "46105",
  "2025-03-23": "03093",
  "2025-03-24": "46238",
  "2025-03-25": "12009",
  "2025-03-26": "46077",
  "2025-03-27": "03050",
  "2025-03-28": "12029",
  "2025-03-29": "03121",
  "2025-03-30": "46035",
  "2025-03-31": "46078",
  "2025-04-01": "12085",
  "2025-04-02": "03101",
  "2025-04-03": "46169",
  "2025-04-04": "12037",
  "2025-04-05": "12079",
  "2025-04-06": "46190",
  "2025-04-07": "03902",
  "2025-04-08": "03092",
  "2025-04-09": "12026",
  "2025-04-10": "46256",
  "2025-04-11": "03059",
  "2025-04-12": "12104",
  "2025-04-13": "03090",
  "2025-04-14": "46070",
  "2025-04-15": "12040",
  "2025-04-16": "03081",
  "2025-04-17": "46186",
  "2025-04-18": "12140",
  "2025-04-19": "03071",
  "2025-04-20": "46081",
  "2025-04-21": "03096",
  "2025-04-22": "03002",
  "2025-04-23": "12139",
  "2025-04-24": "46183",
  "2025-04-25": "46117",
  "2025-04-26": "03053",
  "2025-04-27": "03122",
  "2025-04-28": "46903",
  "2025-04-29": "46071",
  "2025-04-30": "03011",
  "2025-05-01": "46122",
  "2025-05-02": "03043",
  "2025-05-03": "46015",
  "2025-05-04": "12004",
  "2025-05-05": "46170",
  "2025-05-06": "03119",
  "2025-05-07": "46094",
  "2025-05-08": "12022",
  "2025-05-09": "46113",
  "2025-05-10": "03138",
  "2025-05-11": "46074",
  "2025-05-12": "12901",
  "2025-05-13": "46231",
  "2025-05-14": "46148",
  "2025-05-15": "03019",
  "2025-05-16": "12033",
  "2025-05-17": "46156",
  "2025-05-18": "46202",
  "2025-05-19": "03104",
  "2025-05-20": "46228",
  "2025-05-21": "46089",
  "2025-05-22": "46021",
  "2025-05-23": "46214",
  "2025-05-24": "03015",
  "2025-05-25": "12115",
  "2025-05-26": "46134",
  "2025-05-27": "46174",
  "2025-05-28": "12050",
  "2025-05-29": "46032",
  "2025-05-30": "46037",
  "2025-05-31": "12127",
  "2025-06-01": "46224",
  "2025-06-02": "03047",
  "2025-06-03": "46129",
  "2025-06-04": "46104",
  "2025-06-05": "03060",
  "2025-06-06": "12021",
  "2025-06-07": "46230",
  "2025-06-08": "46099",
  "2025-06-09": "03133",
  "2025-06-10": "12068",
  "2025-06-11": "46246",
  "2025-06-12": "46205",
  "2025-06-13": "03006",
  "2025-06-14": "46011",
  "2025-06-15": "46082",
  "2025-06-16": "46112",
  "2025-06-17": "12011",
  "2025-06-18": "46044",
  "2025-06-19": "46178",
  "2025-06-20": "12077",
  "2025-06-21": "46110",
  "2025-06-22": "46139",
  "2025-06-23": "03094",
  "2025-06-24": "46039",
  "2025-06-25": "03064",
  "2025-06-26": "12110",
  "2025-06-27": "46160",
  "2025-06-28": "46239",
  "2025-06-29": "03075",
  "2025-06-30": "46250",
  "2025-07-01": "46207",
  "2025-07-02": "03021",
  "2025-07-03": "46027",
  "2025-07-04": "12012",
  "2025-07-05": "46177",
  "2025-07-06": "46086",
  "2025-07-07": "46223",
  "2025-07-08": "46132",
  "2025-07-09": "12005",
  "2025-07-10": "46005",
  "2025-07-11": "03028",
  "2025-07-12": "46206",
  "2025-07-13": "46258",
  "2025-07-14": "03089",
  "2025-07-15": "12122",
  "2025-07-16": "46022",
  "2025-07-17": "46109",
  "2025-07-18": "03129",
  "2025-07-19": "46041",
  "2025-07-20": "12141",
  "2025-07-21": "46143",
  "2025-07-22": "03136",
  "2025-07-23": "46116",
  "2025-07-24": "46079",
  "2025-07-25": "46165",
  "2025-07-26": "03049",
  "2025-07-27": "46085",
  "2025-07-28": "46067",
  "2025-07-29": "46234",
  "2025-07-30": "03069",
  "2025-07-31": "46123",
  "2025-08-01": "03114",
  "2025-08-02": "12142",
  "2025-08-03": "46248",
  "2025-08-04": "46018",
  "2025-08-05": "03095",
  "2025-08-06": "46088",
  "2025-08-07": "03137",
  "2025-08-08": "46084",
  "2025-08-09": "03107",
  "2025-08-10": "46163",
  "2025-08-11": "03091",
  "2025-08-12": "46098",
  "2025-08-13": "03116",
  "2025-08-14": "46073",
  "2025-08-15": "03113",
  "2025-08-16": "12056",
  "2025-08-17": "46188",
  "2025-08-18": "03130",
  "2025-08-19": "12031",
  "2025-08-20": "03041",
  "2025-08-21": "46167",
  "2025-08-22": "12052",
  "2025-08-23": "03901",
  "2025-08-24": "03020",
  "2025-08-25": "46020",
  "2025-08-26": "12036",
  "2025-08-27": "03012",
  "2025-08-28": "46120",
  "2025-08-29": "46902",
  "2025-08-30": "03003",
  "2025-08-31": "46242",
  "2025-09-01": "03088",
  "2025-09-02": "46072",
  "2025-09-03": "12028",
  "2025-09-04": "03140",
  "2025-09-05": "12087",
  "2025-09-06": "46106",
  "2025-09-07": "46179",
  "2025-09-08": "46137",
  "2025-09-09": "46111",
  "2025-09-10": "03097",
  "2025-09-11": "12124",
  "2025-09-12": "12093",
  "2025-09-13": "03066",
  "2025-09-14": "46213",
  "2025-09-15": "03083",
  "2025-09-16": "03037",
  "2025-09-17": "12126",
  "2025-09-18": "46232",
  "2025-09-19": "46019",
  "2025-09-20": "46236",
  "2025-09-21": "46125",
  "2025-09-22": "46046",
  "2025-09-23": "46195",
  "2025-09-24": "46006",
  "2025-09-25": "46150",
  "2025-09-26": "03051",
  "2025-09-27": "03009",
  "2025-09-28": "12055",
  "2025-09-29": "46226",
  "2025-09-30": "03103",
  "2025-10-01": "12129",
  "2025-10-02": "46235",
  "2025-10-03": "03076",
  "2025-10-04": "46244",
  "2025-10-05": "03135",
  "2025-10-06": "46254",
  "2025-10-07": "12073",
  "2025-10-08": "12039",
  "2025-10-09": "12114",
  "2025-10-10": "03023",
  "2025-10-11": "46009",
  "2025-10-12": "46054",
  "2025-10-13": "12034",
  "2025-10-14": "03903",
  "2025-10-15": "46058",
  "2025-10-16": "46182",
  "2025-10-17": "46193",
  "2025-10-18": "03039",
  "2025-10-19": "46260",
  "2025-10-20": "12061",
  "2025-10-21": "12100",
  "2025-10-22": "46036",
  "2025-10-23": "46017",
  "2025-10-24": "12027",
  "2025-10-25": "46001",
  "2025-10-26": "12092",
  "2025-10-27": "46181",
  "2025-10-28": "12014",
  "2025-10-29": "46097",
  "2025-10-30": "46042",
  "2025-10-31": "46105",
  "2025-11-01": "46191",
  "2025-11-02": "03025",
  "2025-11-03": "03111",
  "2025-11-04": "46126",
  "2025-11-05": "03031",
  "2025-11-06": "46048",
  "2025-11-07": "12071",
  "2025-11-08": "46029",
  "2025-11-09": "46107",
  "2025-11-10": "03084",
  "2025-11-11": "46087",
  "2025-11-12": "46157",
  "2025-11-13": "03011",
  "2025-11-14": "46122",
  "2025-11-15": "03043",
  "2025-11-16": "46015",
  "2025-11-17": "46115",
  "2025-11-18": "03026",
  "2025-11-19": "03115",
  "2025-11-20": "12082",
  "2025-11-21": "03112",
  "2025-11-22": "46166",
  "2025-11-23": "03099",
  "2025-11-24": "12109",
  "2025-11-25": "03098",
  "2025-11-26": "46251",
  "2025-11-27": "12902",
  "2025-11-28": "03118",
  "2025-11-29": "12053",
  "2025-11-30": "46080",
  "2025-12-01": "03042",
  "2025-12-02": "03139",
  "2025-12-03": "46128",
  "2025-12-04": "12051",
  "2025-12-05": "03065",
  "2025-12-06": "46066",
  "2025-12-07": "12135",
  "2025-12-08": "03056",
  "2025-12-09": "03102",
  "2025-12-10": "46147",
  "2025-12-11": "46026",
  "2025-12-12": "46060",
  "2025-12-13": "46197",
  "2025-12-14": "46145",
  "2025-12-15": "46023",
  "2025-12-16": "46229",
  "2025-12-17": "46198",
  "2025-12-18": "46062",
  "2025-12-19": "46144",
  "2025-12-20": "46130",
  "2025-12-21": "12001",
  "2025-12-22": "03048",
  "2025-12-23": "46118",
  "2025-12-24": "03128",
  "2025-12-25": "03032",
  "2025-12-26": "12119",
  "2025-12-27": "12015",
  "2025-12-28": "12113",
  "2025-12-29": "12008",
  "2025-12-30": "03120",
  "2025-12-31": "12067",
  "2026-01-01": "46172",
  "2026-01-02": "46138",
  "2026-01-03": "03123",
  "2026-01-04": "46171",
  "2026-01-05": "12123",
  "2026-01-06": "03063",
  "2026-01-07": "12138",
  "2026-01-08": "03105",
  "2026-01-09": "46131",
  "2026-01-10": "46014",
  "2026-01-11": "12069",
  "2026-01-12": "46237",
  "2026-01-13": "46124",
  "2026-01-14": "46218",
  "2026-01-15": "46199",
  "2026-01-16": "46168",
  "2026-01-17": "03079",
  "2026-01-18": "12032",
  "2026-01-19": "46257",
  "2026-01-20": "03002",
  "2026-01-21": "46203",
  "2026-01-22": "46209",
  "2026-01-23": "46216",
  "2026-01-24": "12043",
  "2026-01-25": "46093",
  "2026-01-26": "46159",
  "2026-01-27": "12133",
  "2026-01-28": "46220",
  "2026-01-29": "12080",
  "2026-01-30": "46176",
  "2026-01-31": "12088",
  "2026-02-01": "03124",
  "2026-02-02": "46057",
  "2026-02-03": "46013",
  "2026-02-04": "12059",
  "2026-02-05": "03014",
  "2026-02-06": "46102",
  "2026-02-07": "12128",
  "2026-02-08": "46127",
  "2026-02-09": "46136",
  "2026-02-10": "46178",
  "2026-02-11": "46139",
  "2026-02-12": "46045",
  "2026-02-13": "46110",
  "2026-02-14": "46246",
  "2026-02-15": "46205",
  "2026-02-16": "03006",
  "2026-02-17": "46011",
  "2026-02-18": "46082",
  "2026-02-19": "46112",
  "2026-02-20": "12077",
  "2026-02-21": "46178",
  "2026-02-22": "12077",
  "2026-02-23": "12044",
  "2026-02-24": "12070",
  "2026-02-25": "03005",
  "2026-02-26": "12138",
  "2026-02-27": "03024",
  "2026-02-28": "46010",
  "2026-03-01": "46051",
  "2026-03-02": "12089",
  "2026-03-03": "03058",
  "2026-03-04": "03036",
  "2026-03-05": "03016",
  "2026-03-06": "46030",
  "2026-03-07": "03062",
  "2026-03-08": "46101",
  "2026-03-09": "03105",
  "2026-03-10": "12093",
  "2026-03-11": "03068",
  "2026-03-12": "46252",
  "2026-03-13": "03044",
  "2026-03-14": "12038",
  "2026-03-15": "46245",
  "2026-03-16": "46076",
  "2026-03-17": "03070",
  "2026-03-18": "03054",
  "2026-03-19": "03095",
  "2026-03-20": "12096",
  "2026-03-21": "12098",
  "2026-03-22": "03099",
  "2026-03-23": "03033",
  "2026-03-24": "03100",
  "2026-03-25": "03013",
  "2026-03-26": "03117",
  "2026-03-27": "03125",
  "2026-03-28": "03010",
  "2026-03-29": "46114",
  "2026-03-30": "12094",
  "2026-03-31": "03056",
  "2026-04-01": "12103",
  "2026-04-02": "03041",
  "2026-04-03": "03067",
  "2026-04-04": "03068",
  "2026-04-05": "03072",
  "2026-04-06": "03073",
  "2026-04-07": "12083",
  "2026-04-08": "12132",
  "2026-04-09": "12091",
  "2026-04-10": "03138",
  "2026-04-11": "03027",
  "2026-04-12": "03017",
  "2026-04-13": "03125",
  "2026-04-14": "12021",
  "2026-04-15": "46217",
  "2026-04-16": "12108",
  "2026-04-17": "46149",
  "2026-04-18": "46016",
  "2026-04-19": "46065",
  "2026-04-20": "46040",
  "2026-04-21": "12007",
  "2026-04-22": "46095",
  "2026-04-23": "46108",
  "2026-04-24": "46164",
  "2026-04-25": "46151",
  "2026-04-26": "46155",
  "2026-04-27": "03030",
  "2026-04-28": "46233",
  "2026-04-29": "12006",
  "2026-04-30": "12057",
  "2026-05-01": "46048",
  "2026-05-02": "46096",
  "2026-05-03": "12020",
  "2026-05-04": "12097",
  "2026-05-05": "46059",
  "2026-05-06": "03029",
  "2026-05-07": "12095",
  "2026-05-08": "46113",
  "2026-05-09": "46049",
  "2026-05-10": "46154",
  "2026-05-11": "46055",
  "2026-05-12": "46068",
  "2026-05-13": "46196",
  "2026-05-14": "46063",
  "2026-05-15": "46200",
  "2026-05-16": "46056",
  "2026-05-17": "46142",
  "2026-05-18": "46225",
  "2026-05-19": "03132",
  "2026-05-20": "12134",
  "2026-05-21": "46069",
  "2026-05-22": "12078",
  "2026-05-23": "46222",
  "2026-05-24": "12058",
  "2026-05-25": "46185",
  "2026-05-26": "12072",
  "2026-05-27": "46215",
  "2026-05-28": "12002",
  "2026-05-29": "46904",
  "2026-05-30": "12024",
  "2026-05-31": "12048",
  "2026-06-01": "46025",
  "2026-06-02": "46033",
  "2026-06-03": "12106",
  "2026-06-04": "46189",
  "2026-06-05": "12081",
  "2026-06-06": "12063",
  "2026-06-07": "12131",
  "2026-06-08": "12013",
  "2026-06-09": "12015",
  "2026-06-10": "46047",
  "2026-06-11": "12064",
  "2026-06-12": "46086",
  "2026-06-13": "12116",
  "2026-06-14": "12025",
  "2026-06-15": "12012",
  "2026-06-16": "12111",
  "2026-06-17": "03046",
  "2026-06-18": "46240",
  "2026-06-19": "46210",
  "2026-06-20": "46219",
  "2026-06-21": "46003",
  "2026-06-22": "12090",
  "2026-06-23": "46175",
  "2026-06-24": "46075",
  "2026-06-25": "12130",
  "2026-06-26": "46004",
  "2026-06-27": "12010",
  "2026-06-28": "46034",
  "2026-06-29": "46053",
  "2026-06-30": "46208",
  "2026-07-01": "46047",
  "2026-07-02": "12116",
  "2026-07-03": "46090",
  "2026-07-04": "46146",
  "2026-07-05": "46173",
  "2026-07-06": "46255",
  "2026-07-07": "46061",
  "2026-07-08": "46227",
  "2026-07-09": "46259",
  "2026-07-10": "12136",
  "2026-07-11": "03131",
  "2026-07-12": "46140",
  "2026-07-13": "46158",
  "2026-07-14": "46180",
  "2026-07-15": "03085",
  "2026-07-16": "46012",
  "2026-07-17": "46162",
  "2026-07-18": "46241",
  "2026-07-19": "12074",
  "2026-07-20": "46018",
  "2026-07-21": "46031",
  "2026-07-22": "46038",
  "2026-07-23": "03127",
  "2026-07-24": "12112",
  "2026-07-25": "46119",
  "2026-07-26": "12016",
  "2026-07-27": "12075",
  "2026-07-28": "46158",
  "2026-07-29": "03077",
  "2026-07-30": "03086",
  "2026-07-31": "03035",
  "2026-08-01": "46064",
  "2026-08-02": "03038",
  "2026-08-03": "46030",
  "2026-08-04": "12121",
  "2026-08-05": "03019",
  "2026-08-06": "46133",
  "2026-08-07": "03022",
  "2026-08-08": "03055",
  "2026-08-09": "46050",
  "2026-08-10": "46100",
  "2026-08-11": "46024",
  "2026-08-12": "03007",
  "2026-08-13": "12099",
  "2026-08-14": "03104",
  "2026-08-15": "03904",
  "2026-08-16": "46247",
  "2026-08-17": "46008",
  "2026-08-18": "03074",
  "2026-08-19": "46121",
  "2026-08-20": "46243",
  "2026-08-21": "03081",
  "2026-08-22": "12102",
  "2026-08-23": "03134",
  "2026-08-24": "46153",
  "2026-08-25": "46128",
  "2026-08-26": "46221",
  "2026-08-27": "46263",
  "2026-08-28": "12049",
  "2026-08-29": "12107",
  "2026-08-30": "12041",
  "2026-08-31": "03034",
  "2026-09-01": "12137",
  "2026-09-02": "12028",
  "2026-09-03": "03140",
  "2026-09-04": "03018",
  "2026-09-05": "12089",
  "2026-09-06": "46249",
  "2026-09-07": "46145",
  "2026-09-08": "46092",
  "2026-09-09": "46194",
  "2026-09-10": "46001",
  "2026-09-11": "46211",
  "2026-09-12": "03066",
  "2026-09-13": "46213",
  "2026-09-14": "03083",
  "2026-09-15": "12138",
  "2026-09-16": "03076",
  "2026-09-17": "46131",
  "2026-09-18": "03079",
  "2026-09-19": "46235",
  "2026-09-20": "03076",
  "2026-09-21": "46244",
  "2026-09-22": "46152",
  "2026-09-23": "46071",
  "2026-09-24": "46017",
  "2026-09-25": "12027",
  "2026-09-26": "03009",
  "2026-09-27": "46126",
  "2026-09-28": "03031",
  "2026-09-29": "46002",
  "2026-09-30": "12071",
  "2026-10-01": "46029",
  "2026-10-02": "46159",
  "2026-10-03": "46052",
  "2026-10-04": "46220",
  "2026-10-05": "12080",
  "2026-10-06": "46007",
  "2026-10-07": "46147",
  "2026-10-08": "12045",
  "2026-10-09": "12032",
  "2026-10-10": "46257",
  "2026-10-11": "03139",
  "2026-10-12": "46128",
  "2026-10-13": "12051",
  "2026-10-14": "03065",
  "2026-10-15": "12042",
  "2026-10-16": "12135",
  "2026-10-17": "46043",
  "2026-10-18": "03102",
  "2026-10-19": "12082",
  "2026-10-20": "46204",
  "2026-10-21": "46166",
  "2026-10-22": "03001",
  "2026-10-23": "12109",
  "2026-10-24": "46184",
  "2026-10-25": "46201",
  "2026-10-26": "12003",
  "2026-10-27": "03127",
  "2026-10-28": "46083",
  "2026-10-29": "12117",
  "2026-10-30": "46135",
  "2026-10-31": "03082",
  "2026-11-01": "12046",
  "2026-11-02": "12084",
  "2026-11-03": "03048",
  "2026-11-04": "46118",
  "2026-11-05": "03128",
  "2026-11-06": "46250",
  "2026-11-07": "46057",
  "2026-11-08": "46013",
  "2026-11-09": "12059",
  "2026-11-10": "03014",
  "2026-11-11": "46102",
  "2026-11-12": "12128",
  "2026-11-13": "03106",
  "2026-11-14": "46181",
  "2026-11-15": "12014",
  "2026-11-16": "46097",
  "2026-11-17": "46042",
  "2026-11-18": "46105",
  "2026-11-19": "03093",
  "2026-11-20": "46238",
  "2026-11-21": "12009",
  "2026-11-22": "46077",
  "2026-11-23": "03050",
  "2026-11-24": "12029",
  "2026-11-25": "03121",
  "2026-11-26": "46035",
  "2026-11-27": "46078",
  "2026-11-28": "12085",
  "2026-11-29": "03101",
  "2026-11-30": "46169",
  "2026-12-01": "12037",
  "2026-12-02": "12079",
  "2026-12-03": "46190",
  "2026-12-04": "03902",
  "2026-12-05": "03092",
  "2026-12-06": "12026",
  "2026-12-07": "46256",
  "2026-12-08": "03059",
  "2026-12-09": "12104",
  "2026-12-10": "03090",
  "2026-12-11": "46070",
  "2026-12-12": "12040",
  "2026-12-13": "03081",
  "2026-12-14": "46186",
  "2026-12-15": "12140",
  "2026-12-16": "03071",
  "2026-12-17": "46081",
  "2026-12-18": "03096",
  "2026-12-19": "03002",
  "2026-12-20": "12139",
  "2026-12-21": "46183",
  "2026-12-22": "46117",
  "2026-12-23": "03053",
  "2026-12-24": "03122",
  "2026-12-25": "46903",
  "2026-12-26": "46254",
  "2026-12-27": "03011",
  "2026-12-28": "46261",
  "2026-12-29": "03043",
  "2026-12-30": "46015",
  "2026-12-31": "12004",
  "2027-01-01": "46170",
  "2027-01-02": "03119",
  "2027-01-03": "46094",
  "2027-01-04": "12022",
  "2027-01-05": "46113",
  "2027-01-06": "03138",
  "2027-01-07": "46074",
  "2027-01-08": "12901",
  "2027-01-09": "46231",
  "2027-01-10": "46148",
  "2027-01-11": "03019",
  "2027-01-12": "12033",
  "2027-01-13": "46156",
  "2027-01-14": "46202",
  "2027-01-15": "03104",
  "2027-01-16": "46228",
  "2027-01-17": "46089",
  "2027-01-18": "46021",
  "2027-01-19": "46214",
  "2027-01-20": "03015",
  "2027-01-21": "12115",
  "2027-01-22": "46134",
  "2027-01-23": "46174",
  "2027-01-24": "12050",
  "2027-01-25": "46032",
  "2027-01-26": "46037",
  "2027-01-27": "12127",
  "2027-01-28": "46224",
  "2027-01-29": "03047",
  "2027-01-30": "46129",
  "2027-01-31": "46104",
  "2027-02-01": "03060",
  "2027-02-02": "12021",
  "2027-02-03": "46230",
  "2027-02-04": "46099",
  "2027-02-05": "03133",
  "2027-02-06": "12068",
  "2027-02-07": "46246",
  "2027-02-08": "46205",
  "2027-02-09": "03006",
  "2027-02-10": "46011",
  "2027-02-11": "46082",
  "2027-02-12": "46112",
  "2027-02-13": "12011",
  "2027-02-14": "46044",
  "2027-02-15": "46028",
  "2027-02-16": "03008",
  "2027-02-17": "46110",
  "2027-02-18": "46139",
  "2027-02-19": "03094",
  "2027-02-20": "46039",
  "2027-02-21": "03064",
  "2027-02-22": "12110",
  "2027-02-23": "46160",
  "2027-02-24": "46239",
  "2027-02-25": "03075",
  "2027-02-26": "46250",
  "2027-02-27": "46207",
  "2027-02-28": "03021",
  "2027-03-01": "46027",
  "2027-03-02": "12012",
  "2027-03-03": "46177",
  "2027-03-04": "46086",
  "2027-03-05": "46223",
  "2027-03-06": "46132",
  "2027-03-07": "12005",
  "2027-03-08": "46005",
  "2027-03-09": "03028",
  "2027-03-10": "46206",
  "2027-03-11": "46258",
  "2027-03-12": "03089",
  "2027-03-13": "12122",
  "2027-03-14": "46022",
  "2027-03-15": "46109",
  "2027-03-16": "03129",
  "2027-03-17": "46041",
  "2027-03-18": "12141",
  "2027-03-19": "46143",
  "2027-03-20": "03136",
  "2027-03-21": "46116",
  "2027-03-22": "46079",
  "2027-03-23": "46165",
  "2027-03-24": "03049",
  "2027-03-25": "46085",
  "2027-03-26": "46067",
  "2027-03-27": "46234",
  "2027-03-28": "03069",
  "2027-03-29": "46123",
  "2027-03-30": "03114",
  "2027-03-31": "12142",
  "2027-04-01": "46248",
  "2027-04-02": "46018",
  "2027-04-03": "03095",
  "2027-04-04": "46088",
  "2027-04-05": "03137",
  "2027-04-06": "46084",
  "2027-04-07": "03107",
  "2027-04-08": "46163",
  "2027-04-09": "03091",
  "2027-04-10": "46098",
  "2027-04-11": "03116",
  "2027-04-12": "46073",
  "2027-04-13": "03113",
  "2027-04-14": "12056",
  "2027-04-15": "46188",
  "2027-04-16": "03130",
  "2027-04-17": "12031",
  "2027-04-18": "03041",
  "2027-04-19": "46167",
  "2027-04-20": "12052",
  "2027-04-21": "03901",
  "2027-04-22": "03020",
  "2027-04-23": "46020",
  "2027-04-24": "12036",
  "2027-04-25": "03012",
  "2027-04-26": "46120",
  "2027-04-27": "46902",
  "2027-04-28": "03003",
  "2027-04-29": "46242",
  "2027-04-30": "03088",
  "2027-05-01": "46072",
  "2027-05-02": "12028",
  "2027-05-03": "03140",
  "2027-05-04": "12087",
  "2027-05-05": "46106",
  "2027-05-06": "03065",
  "2027-05-07": "46070",
  "2027-05-08": "46078",
  "2027-05-09": "46256",
  "2027-05-10": "12080",
  "2027-05-11": "12018",
  "2027-05-12": "12078",
  "2027-05-13": "12038",
  "2027-05-14": "03040",
  "2027-05-15": "46144",
  "2027-05-16": "12082",
  "2027-05-17": "12130",
  "2027-05-18": "03045",
  "2027-05-19": "03057",
  "2027-05-20": "46077",
  "2027-05-21": "12004",
  "2027-05-22": "46213",
  "2027-05-23": "03134",
  "2027-05-24": "46235",
  "2027-05-25": "03051",
  "2027-05-26": "12100",
  "2027-05-27": "12055",
  "2027-05-28": "03140",
  "2027-05-29": "46249",
  "2027-05-30": "46029",
  "2027-05-31": "46005",
  "2027-06-01": "12104",
  "2027-06-02": "46244",
  "2027-06-03": "03135",
  "2027-06-04": "46254",
  "2027-06-05": "12073",
  "2027-06-06": "12039",
  "2027-06-07": "12114",
  "2027-06-08": "46147",
  "2027-06-09": "46009",
  "2027-06-10": "46054",
  "2027-06-11": "12034",
  "2027-06-12": "03903",
  "2027-06-13": "46058",
  "2027-06-14": "46182",
  "2027-06-15": "46193",
  "2027-06-16": "03076",
  "2027-06-17": "46260",
  "2027-06-18": "46131",
  "2027-06-19": "03009",
  "2027-06-20": "46036",
  "2027-06-21": "46017",
  "2027-06-22": "12027",
  "2027-06-23": "12105",
  "2027-06-24": "12092",
  "2027-06-25": "46181",
  "2027-06-26": "12014",
  "2027-06-27": "46097",
  "2027-06-28": "46042",
  "2027-06-29": "46105",
  "2027-06-30": "46191",
  "2027-07-01": "03025",
  "2027-07-02": "03111",
  "2027-07-03": "46253",
  "2027-07-04": "03045",
  "2027-07-05": "46048",
  "2027-07-06": "12071",
  "2027-07-07": "12129",
  "2027-07-08": "46107",
  "2027-07-09": "03084",
  "2027-07-10": "46087",
  "2027-07-11": "46157",
  "2027-07-12": "03011",
  "2027-07-13": "46122",
  "2027-07-14": "46161",
  "2027-07-15": "46015",
  "2027-07-16": "46115",
  "2027-07-17": "03026",
  "2027-07-18": "03115",
  "2027-07-19": "12082",
  "2027-07-20": "03112",
  "2027-07-21": "46166",
  "2027-07-22": "03099",
  "2027-07-23": "46103",
  "2027-07-24": "03098",
  "2027-07-25": "46251",
  "2027-07-26": "12902",
  "2027-07-27": "03118",
  "2027-07-28": "12053",
  "2027-07-29": "46080",
  "2027-07-30": "03042",
  "2027-07-31": "03139",
  "2027-08-01": "03004",
  "2027-08-02": "46192",
  "2027-08-03": "03065",
  "2027-08-04": "46066",
  "2027-08-05": "12135",
  "2027-08-06": "03056",
  "2027-08-07": "03102",
  "2027-08-08": "46147",
  "2027-08-09": "46026",
  "2027-08-10": "46060",
  "2027-08-11": "46197",
  "2027-08-12": "46145",
  "2027-08-13": "46023",
  "2027-08-14": "46229",
  "2027-08-15": "46198",
  "2027-08-16": "46062",
  "2027-08-17": "46144",
  "2027-08-18": "46130",
  "2027-08-19": "12001",
  "2027-08-20": "46212",
  "2027-08-21": "46118",
  "2027-08-22": "03109",
  "2027-08-23": "03032",
  "2027-08-24": "12119",
  "2027-08-25": "12015",
  "2027-08-26": "12113",
  "2027-08-27": "12008",
  "2027-08-28": "03120",
  "2027-08-29": "12067",
  "2027-08-30": "46172",
  "2027-08-31": "46138",
  "2027-09-01": "03123",
  "2027-09-02": "46171",
  "2027-09-03": "12123",
  "2027-09-04": "03063",
  "2027-09-05": "12138",
  "2027-09-06": "03105",
  "2027-09-07": "46131",
  "2027-09-08": "12045",
  "2027-09-09": "46235",
  "2027-09-10": "03076",
  "2027-09-11": "46244",
  "2027-09-12": "12126",
  "2027-09-13": "46254",
  "2027-09-14": "03079",
  "2027-09-15": "12027",
  "2027-09-16": "46001",
  "2027-09-17": "46126",
  "2027-09-18": "03031",
  "2027-09-19": "46007",
  "2027-09-20": "46017",
  "2027-09-21": "46029",
  "2027-09-22": "46159",
  "2027-09-23": "12032",
  "2027-09-24": "46220"
};

export function getDayString(shiftDayCount?: number) {
  return DateTime.now()
    .plus({ days: shiftDayCount ?? 0 })
    .toFormat("yyyy-MM-dd");
}

export function useTodays(dayString: string): [
  {
    town?: Town;
    guesses: Guess[];
  },
  (guess: Guess) => void,
  number,
  number
] {
  const [todays, setTodays] = useState<{
    town?: Town;
    guesses: Guess[];
  }>({ guesses: [] });

  const addGuess = useCallback(
    (newGuess: Guess) => {
      if (todays == null) {
        return;
      }

      const newGuesses = [...todays.guesses, newGuess];

      setTodays((prev) => ({ town: prev.town, guesses: newGuesses }));
      saveGuesses(dayString, newGuesses);
    },
    [dayString, todays]
  );

  useEffect(() => {
    const guesses = loadAllGuesses()[dayString] ?? [];
    const town = getTown(dayString);

    setTodays({ town, guesses });
  }, [dayString]);

  const randomAngle = useMemo(
    () => seedrandom.alea(dayString)() * 360,
    [dayString]
  );

  const imageScale = useMemo(() => {
    const normalizedAngle = 45 - (randomAngle % 90);
    const radianAngle = (normalizedAngle * Math.PI) / 180;
    return 1 / (Math.cos(radianAngle) * Math.sqrt(2));
  }, [randomAngle]);

  return [todays, addGuess, randomAngle, imageScale];
}

function getTown(dayString: string) {
  /*const currentDayDate = DateTime.fromFormat(dayString, "yyyy-MM-dd");
  let pickingDate = DateTime.fromFormat("2022-03-21", "yyyy-MM-dd");
  let smallTownCooldown = 0;
  let pickedTown: Town | null = null;

  do {
    smallTownCooldown--;

    const pickingDateString = pickingDate.toFormat("yyyy-MM-dd");*/

    const forcedTownCode = forcedTowns[dayString];
    const forcedTown =
    forcedTownCode != null
      ? townsWithImage.find((town) => town.code === forcedTownCode)
      : undefined;

  return (
    forcedTown ??
    townsWithImage[
      Math.floor(seedrandom.alea(dayString)() * townsWithImage.length)
    ]
  );
}